import Cookie from 'js-cookie';


export function request(endpoint, options = null) {
if (options) options['headers']['Authorization'] = `Bearer ${Cookie.get('jwt')}`;
else options = { headers: { Authorization: `Bearer ${Cookie.get('jwt')}` }}

  return fetch(`${process.env.REACT_APP_URL}${endpoint}`, {...options});
}
